import React from "react";
import { Link } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  ArrowUpRight,
  Droplets,
  Activity,
  Factory,
  ShieldCheck,
} from "lucide-react";
import logo from "../images/Hydrotec Logo.png";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Projects", path: "/projects" },
  { label: "Monitoring", path: "/monitoring" },
  { label: "Contact", path: "/contact" },
];

const solutionLinks = [
  { label: "Water ATM Solutions", path: "/solutions/water-atm", icon: Droplets },
  { label: "Pump Systems", path: "/solutions/pumps", icon: Activity },
  { label: "Water Treatment", path: "/solutions/water-treatment", icon: ShieldCheck },
  { label: "Wastewater Solutions", path: "/solutions/wastewater", icon: Factory },
];

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="border-t border-white/10">
        <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 sm:px-8 lg:grid-cols-[1.15fr_0.7fr_0.85fr] lg:px-10">
          <div>
            <img
              src={logo}
              alt="Hydrotec Solutions Private Limited"
              className="h-12 w-auto object-contain"
            />

            <p className="mt-4 max-w-xl text-base leading-7 text-white/68">
              Hydrotec Solutions Private Limited builds premium water
              infrastructure for public systems, institutions, industrial sites,
              and community-scale deployment.
            </p>

            <div className="mt-6 grid gap-3 sm:grid-cols-2">
              

              <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-4" />
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.35em] text-white/45">
              Navigate
            </p>

            <div className="mt-5 space-y-2.5">
              {quickLinks.map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  className="group inline-flex items-center text-sm font-medium text-white/72 transition hover:text-white"
                >
                  {item.label}
                  <ArrowUpRight className="ml-2 h-4 w-4 opacity-0 transition group-hover:opacity-100" />
                </Link>
              ))}
            </div>

            <p className="mt-8 text-xs font-semibold uppercase tracking-[0.35em] text-white/45">
              Solutions
            </p>

            <div className="mt-5 space-y-3">
              {solutionLinks.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.label}
                    to={item.path}
                    className="group flex items-center gap-3 text-sm text-white/68 transition hover:text-white"
                  >
                    <span className="flex h-8 w-8 items-center justify-center rounded-xl border border-white/10 bg-white/[0.04] text-cyan-300">
                      <Icon className="h-4 w-4" />
                    </span>
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.35em] text-white/45">
              Contact
            </p>

            <div className="mt-5 space-y-4">
              <div className="flex items-start gap-3">
                <div className="mt-1 rounded-xl border border-white/10 bg-white/[0.04] p-2 text-cyan-300">
                  <Phone className="h-4 w-4" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-white/45">
                    Phone
                  </p>
                  <p className="mt-1 text-sm text-white/82">+91 8697702088</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="mt-1 rounded-xl border border-white/10 bg-white/[0.04] p-2 text-cyan-300">
                  <Mail className="h-4 w-4" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-white/45">
                    Email
                  </p>
                  <p className="mt-1 text-sm text-white/82">
                    info@hydroteclimited.com
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="mt-1 rounded-xl border border-white/10 bg-white/[0.04] p-2 text-cyan-300">
                  <MapPin className="h-4 w-4" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-white/45">
                    Address
                  </p>
                  <p className="mt-1 text-sm leading-6 text-white/82">
                    CC- 100, Street- 233, Newtown, <br />
                    Kolkata- 700156, West Bengal, India
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-4 text-sm text-white/45 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:px-10">
          <p>© 2026 Hydrotec Solutions Private Limited. All rights reserved.</p>
          <div className="flex flex-wrap gap-4">
            <Link to="/" className="transition hover:text-white/75">
              Privacy
            </Link>
            <Link to="/" className="transition hover:text-white/75">
              Terms
            </Link>
            <Link to="/contact" className="transition hover:text-white/75">
              Enquiry
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}